import styled from 'styled-components';

export const CarouselRoot = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamily};
  background: ${({ theme }) => theme.colors.card};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadowCard};
`;

export const SlideLink = styled.a`
  display: block;
  position: relative;
  color: inherit;
  text-decoration: none;
`;

export const SlideImage = styled.img`
  width: 100%;
  height: 192px;
  object-fit: cover;
  display: block;

  @media (min-width: 768px) {
    height: 256px;
  }
`;

export const SlideScrim = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.82) 0%, rgba(0, 0, 0, 0.2) 55%, transparent 100%);
  pointer-events: none;
`;

export const SlideContent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1.35rem 1.25rem 1.5rem;
  pointer-events: none;

  @media (min-width: 768px) {
    padding: 1.65rem 1.75rem 1.85rem;
  }
`;

export const SponsorBadge = styled.span`
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 14px);
  background: rgba(234, 179, 8, 0.35);
  color: ${({ theme }) => theme.colors.goldForeground};
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.5rem;
`;

export const SlideTitle = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.xl};
  font-weight: 700;
  line-height: 1.25;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);

  @media (min-width: 768px) {
    font-size: ${({ theme }) => theme.fontClamp['2xl']};
  }
`;

export const SlideDesc = styled.p`
  margin: 0.5rem 0 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: rgba(255, 255, 255, 0.92);
  max-width: 38rem;
  line-height: 1.55;

  @media (min-width: 768px) {
    font-size: ${({ theme }) => theme.fontClamp.base};
  }
`;

export const CtaPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.85rem;
  padding: 0.55rem 1.1rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 8px);
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
`;

export const NavBtn = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(p) => (p.$side === 'left' ? 'left: 12px;' : 'right: 12px;')}
  width: 36px;
  height: 36px;
  border: none;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 12px);
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;

  &:hover {
    background: rgba(0, 0, 0, 0.65);
  }
`;

export const Dots = styled.div`
  position: absolute;
  bottom: 10px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 3;
`;

export const Dot = styled.button`
  width: ${({ $active }) => ($active ? '16px' : '8px')};
  height: 8px;
  border: none;
  border-radius: 999px;
  padding: 0;
  cursor: pointer;
  background: ${({ $active, theme }) => ($active ? theme.colors.gold : 'rgba(255,255,255,0.45)')};
  transition: width 0.2s, background 0.2s;
`;
